"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixDotsInText = fixDotsInText;
function fixDotsInText(tex) {
    return tex.replace(new RegExp(`\\\\text\\s*{\\s*([^}]*)}`, "g"), (textNode) => {
        return textNode.replace(new RegExp(`[$]?\\\\dots`, "g"), (token) => {
            if (token.startsWith("$")) {
                return token;
            }
            return `$${token}$`;
        });
    });
}
